var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "fluid__video single-cinemagraph",
        class: { incomplete: _vm.status !== "complete" }
      },
      [
        _c("iframe", {
          attrs: { src: _vm.flixel.player_url, allow: "autoplay" }
        }),
        _vm.savedList.index
          ? _c(
              "a",
              {
                staticClass: "slideshow__actions prev",
                on: {
                  click: function($event) {
                    _vm.skipTo("prev")
                  }
                }
              },
              [
                _c("img", {
                  attrs: {
                    srcset:
                      "images/gallery/arrow-left@2x.png" +
                      " 2x, " +
                      "images/gallery/arrow-left.png" +
                      " 1x"
                  }
                })
              ]
            )
          : _vm._e(),
        _vm.showNext(_vm.savedList)
          ? _c(
              "a",
              {
                staticClass: "slideshow__actions next",
                on: {
                  click: function($event) {
                    _vm.skipTo("next")
                  }
                }
              },
              [
                _c("img", {
                  attrs: {
                    srcset:
                      "images/gallery/arrow-right@2x.png" +
                      " 2x, " +
                      "images/gallery/arrow-right.png" +
                      " 1x"
                  }
                })
              ]
            )
          : _vm._e()
      ]
    ),
    _vm.status !== "complete"
      ? _c("div", { staticClass: "h-cover" }, [
          _c("div", { staticClass: "background list--shadow h-textcenter" }, [
            _vm.status !== "complete" && _vm.status !== "failed"
              ? _c("p", { staticClass: "h-white h-bold" }, [
                  _vm._v("We are processing your cinemagraph.")
                ])
              : _vm._e(),
            _vm.status === "failed"
              ? _c("p", { staticClass: "h-white h-bold" }, [
                  _vm._v(
                    "We could not process your cinemagraph. Please try uploading again."
                  )
                ])
              : _vm._e()
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09d89f18", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09d89f18","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SingleFlixel.vue
// module id = null
// module chunks = 